// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDbHtgOdPR89xpTQ3th5ubHrndgEYQz8mQ",
  authDomain: "arora-c02b0.firebaseapp.com",
  projectId: "arora-c02b0",
  storageBucket: "arora-c02b0.appspot.com",
  messagingSenderId: "555891564173",
  appId: "1:555891564173:web:2110c30b115fe633288cc4",
  measurementId: "G-SB4X9VKSCL"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);